import React from "react";
import styled from "styled-components";
import { border, BorderProps, color as c, ColorProps, space, SpaceProps, typography, TypographyProps } from "styled-system";
import { Link } from "../Link";
import { colorSelector } from "../../utils/ColorSelector";

interface Props {
  to: string;
  hover?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

/* TODO:
   Link throws a bug when running on jest.
   https://lifesaver.codes/answer/uncaught-error-cannot-create-styled-component-for-component-undefined

   Desctructuring borderBottom, borderColor, paddingBottom to due to.
   https://github.com/styled-components/styled-components/issues/1814
 */
/* istanbul ignore next */
const LinkRouter = styled(({ borderBottom, borderColor, paddingBottom, hover, ...props }) => <Link {...props} />)`
  ${c}
  ${typography}
  ${border}
  ${space}
  ${({ hover }) =>
    hover
      ? `
    &:hover {
        color: ${colorSelector("hover")}
    }
  `
      : `
  &:hover {
    color: white;

  }
  `}
  text-decoration: none;
  cursor: pointer;
`;

export const MenuItemLink: React.FC<Props & ColorProps & TypographyProps & BorderProps & SpaceProps> = ({
  to,
  hover,
  children,
  ...props
}) => (
  <LinkRouter data-testid="secondaryNavItemLink" to={to} href={to} hover={hover} {...props}>
    {children}
  </LinkRouter>
);

MenuItemLink.defaultProps = {
  hover: false,
};
